module.exports = __webpack_public_path__ + "img/logo-inocencio-paula.52160387.png";